import { Link } from 'react-router-dom';
import { CherryLogo } from './CherryLogo';
import { WalletButton } from './WalletButton';
import { NotificationBell } from './NotificationBell';

interface HeaderProps {
  isDark: boolean;
  onToggleTheme: () => void;
}

export function Header({ isDark, onToggleTheme }: HeaderProps) {
  return (
    <header className="sticky top-0 z-40 bg-surface/80 backdrop-blur-md border-b border-border">
      <div className="mx-auto max-w-3xl flex items-center justify-between px-5 h-14">
        <Link
          to="/"
          className="flex items-center gap-1.5 text-lg font-bold text-cherry-500 no-underline shrink-0"
        >
          <CherryLogo size={24} />
          <span className="hidden sm:inline">Cherry Trading Post</span>
          <span className="sm:hidden">Cherry</span>
        </Link>
        <div className="flex items-center gap-2">
          <button
            onClick={onToggleTheme}
            className="p-1.5 rounded-lg hover:bg-surface-alt transition-colors text-text-muted"
            aria-label="Toggle dark mode"
            title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {isDark ? (
              <svg className="w-4.5 h-4.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m8.66-13.66l-.71.71M4.05 19.95l-.71.71M21 12h-1M4 12H3m16.66 7.66l-.71-.71M4.05 4.05l-.71-.71M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
            ) : (
              <svg className="w-4.5 h-4.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
              </svg>
            )}
          </button>
          <NotificationBell />
          <WalletButton />
        </div>
      </div>
    </header>
  );
}
